<template>
  <div id="stepsBelt" ref="stepBelt" class="oval relative">
    <transition name="fadeMS3">
      <div v-if="route.name !== 'Step11'"
           id="stepRoot"
           class="flex align-center swiper-wrapper oval no--sb"
           :class="{inActive:route.name === 'Step11'}">
        <router-link class="flex-column align-center justify-center swiper-slide"
                     :class="{disabled: freed.includes(step.route) ? !isQueryContainProperty('width') : !isQueryContainProperty(step.property) && step.route !== route.name}"
                     :to="{name:step.route, query:route.query}"
                     active-class="active"
                     v-for="(step, idx) in steps"
                     :key="idx">
          <i v-if="step.route === route.name && route.name === 'Step11'" class="fas fa-check big-check"></i>
          <i v-if="isQueryContainProperty(step.property)" class="fas fa-check"></i>
          <i v-else-if="!isQueryContainProperty(step.property) && isQueryContainProperty('width') && freed.includes(step.route)" class="fas fa-minus"></i>
          <span class="title">{{step.text}}</span>
          <span class="sub-title">{{step.subText}}</span>
        </router-link>
      </div>
      <div v-else class="flex justify-center align-center oval return-button-wrapper" :class="{inActive:route.name === 'Step11'}">
        <button class="flex align-center justify-center pointer" @click="pushTo('Step10', route.query)"><span>前ページに戻る</span></button>
      </div>
    </transition>
  </div>
</template>

<script>
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import {useRoute} from "vue-router";
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import useQueryBuilder from "@/modules/moduleA/helpers/useQueryBuilder";
export default {
  name:"StepsBelt",
  setup(){
    const {} = useQueryBuilder()
    const route = useRoute()
    const {pushTo} = useRoutePush()
    const steps = [
      {route:"Step1", text:"Step.1", subText:"地金", property:"base", disabled:true},
      {route:"Step2", text:"Step.2", subText:"リングのかたち", property:"shape", disabled:true},
      {route:"Step3", text:"Step.3", subText:"テクスチャー", property:"texture", disabled:true},
      {route:"Step4", text:"Step.4", subText:"表面の仕上げ", property:"surface", disabled:true},
      {route:"Step5", text:"Step.5", subText:"リング幅", property:"width", disabled:true},
      {route:"Step6", text:"Step.6", subText:"ミルグレイン", property:"milgrain", disabled:true},
      {route:"Step7", text:"Step.7", subText:"外側ダイヤ", property:"outsideDia", disabled:true},
      {route:"Step8", text:"Step.8", subText:"内石", property:"insideDia", disabled:true},
      {route:"Step9", text:"Step.9", subText:"刻印", property: "ringText", disabled:true},
      {route:"Step10", text:"Step.10", subText:"指輪サイズ", property:"ringSize", disabled:true},
    ]
    const widthSize = ref(104)
    const freed = ref(["Step6","Step7","Step8","Step9",])
    const invoiceOverlay = ref(null)
    const stepBelt = ref(null)

    const isQueryContainProperty = (property) => {
      return route.query.hasOwnProperty(property)
    }

    onMounted(() => {
      setTimeout(()=> {
        scrollToView()
      },200)
    })

    function scrollToView(){
      if (["step2", "step3", "step4", "step5", "step6", "step7", "step8", "step9", "step10"].includes(route.name.toLowerCase())){
        const innerW = window.innerWidth / 2
        const curr = route.name.toLowerCase()
        const root = document.getElementById("stepRoot")
        const ww = curr === "step2" ? 104-innerW : curr === "step3" ? (104*2)-innerW : curr === "step4" ? (104*3)-innerW :
            curr === "step4" ? (104*4)-innerW :
                curr === "step5" ? (104*5)-innerW :
                    curr === "step6" ? (104*6)-innerW :
                        curr === "step7" ? (104*7)-innerW :
                            curr === "step8" ? (104*8)-innerW :
                                curr === "step9" ? (104*9)-innerW :
                                    curr === "step10" ? (104*10)-innerW : 0
        if (root){
          root.scrollTo({top:0, left:ww, behavior:"smooth"})
        }
      }
    }

    watch(() => route.name, () => {
      scrollToView()
    })

    return {pushTo, widthSize, route, steps, isQueryContainProperty, freed, stepBelt, invoiceOverlay}
  }
}
</script>

<style>
#stepsBelt {
  height: 60px;
  width: 100%;
  padding: 0 10px;
  scroll-behavior: smooth;
  background-color: transparent;
}
.invoice-overlay {
  position: absolute;
  overflow-x: hidden;
  z-index: 11;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  transition: 1s;
}

.return-button-wrapper > button {
  position: relative;
  margin: auto;
  height: 62px;
}
.return-button-wrapper > button > .fa-chevron-left {
  opacity: .1;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 48%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
}
.return-button-wrapper > button > span {
  position: relative;
  z-index: 2;
  text-decoration: underline;
}

.swiper-wrapper {
  background-color: #f5f6fa;
  position: relative;
  z-index: 9;
  overflow-x: scroll;
  height: 60px;
  padding: 0 3px;
}
.swiper-wrapper > a.swiper-slide {
  position: relative;
  min-width: 104px;
  height: 84%;
  color: #1e272e;
}
.swiper-wrapper > a.swiper-slide.disabled {
  pointer-events: none;
  opacity: 0.3;
}
.swiper-wrapper > a.swiper-slide::after {
  content: "";
  position: absolute;
  right: -1px;
  width: 1px;
  height: 35%;
  top: 50%;
  background-color: #d2dae2;
  transform: translateY(-50%);
}
.swiper-wrapper > a.swiper-slide:first-child {
  margin-left: 5px;
  border-bottom-left-radius: 14px;
  border-top-left-radius: 14px;
}
.swiper-wrapper > a.swiper-slide.active {
  background-color: #1e272e;
  border-radius: 14px;
  color: white;
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
}
.swiper-wrapper > a.swiper-slide.active::after {
  height: 0;
}
.swiper-wrapper > a.swiper-slide:last-child::after {
  height: 0;
}
.swiper-wrapper > a.swiper-slide > .fas {
  z-index: 9;
  font-size: .7rem;
  color: #ffc048;
  position: absolute;
  right: 8px;
  top: 6px;
}
.swiper-wrapper > a.swiper-slide > .big-check {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: .2;
  font-size: 3rem;
}
.swiper-wrapper > a.swiper-slide > .fa-minus {
  color: #797979;
}
.swiper-wrapper > a.swiper-slide > span.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  background-color: white;
  height: 100%;
}
.swiper-wrapper > a.swiper-slide:first-child > span.overlay {
  border-bottom-left-radius: 14px;
  border-top-left-radius: 14px;
}
.swiper-wrapper > a.swiper-slide > span.title {
  position: relative;
  z-index: 2;
  font-size: .7rem !important;
  color: #171717;
  margin-bottom: 4px;
}
.swiper-wrapper > a.swiper-slide > span.sub-title {
  position: relative;
  z-index: 2;
  color: #171717;
  font-size: .80rem !important;
}
.swiper-wrapper > a.swiper-slide > span.overlay.active {
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
  width: 100%;
  height: 100%;
}
.swiper-wrapper > a.swiper-slide.active > span.title,
.swiper-wrapper > a.swiper-slide.active > span.sub-title {
  color: white;
}

</style>
